import createMulticallPlugin from './generic/createMulticallPlugin';
import { GetOffchainDataV2 } from '../GetOffchainData/GetOffchainDataV2';
export var MultiGetOffchainData = createMulticallPlugin({
    plugin: GetOffchainDataV2,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY:VIEWONLY',
    method: 'multiGetOffchainData',
    name: 'multiGetOffchainData',
    flowType: 'OFFCHAIN_ONLY',
    config: {
        params: [
            { key: 'endpoint', multicallKey: 'endpoint', isUnique: true },
            { key: 'paramKey', multicallKey: 'key' },
            { key: 'paramValue', multicallKey: 'value' },
        ],
        tupleName: 'getresponses',
    },
    addPluginOnInit: true,
    withPluginOutputs: true,
});
